import { StyleSheet } from 'react-native';
import { getTheme } from '../src/theme/getTheme';

const t = getTheme();

export const oauthCallbackStyles = StyleSheet.create({
  fullScreenContainer: {
    flex: 1,
    width: '100%',
    height: '100%',
    backgroundColor: t.background.primary,
  },
});

// Web CSS injection string
export const WEB_OAUTH_CSS = `
  body { overflow: hidden !important; margin: 0 !important; padding: 0 !important; }
  #root, [data-reactroot], [id^="expo"] { margin: 0 !important; padding: 0 !important; }
  nav[role="tablist"] { display: none !important; }
  [role="tablist"] { display: none !important; }
`;

export const OAUTH_CALLBACK_STYLE_ID = 'oauth-callback-styles';

